import { format } from 'date-fns'
import { calendarDay, type CalendarDay } from '@lib/validators/temporal.validator'

/**
 * What a booked-day mark on an event's date picker means. A warning, not a
 * refusal: the booking is refused only if the times overlap too.
 */
export function bookedLabel(trackCount: number): string {
  return trackCount === 1
    ? 'Another event holds this track that day'
    : 'Another event holds one of these tracks that day'
}

/** Today in the browser's calendar, as `yyyy-MM-dd` — where a date picker opens. */
export function todayIso(): CalendarDay {
  return calendarDay(format(new Date(), 'yyyy-MM-dd'))
}
